var BreakingNewsType;
(function (BreakingNewsType) {
    BreakingNewsType["NEWS"] = "News";
    BreakingNewsType["WEATHER"] = "Weather";
    BreakingNewsType["PROMOTION"] = "Promotion";
})(BreakingNewsType || (BreakingNewsType = {}));

export { BreakingNewsType };
//# sourceMappingURL=story.mjs.map
